import React from "react";

type SelectControlsProps = {
    check?: () => void;
    uncheck?: () => void;
    selectControlsLabel?: {
        selectAll?: string;
        reset?: string;
    };
};

function SelectControls({
    check = () => {},
    uncheck = () => {},
    selectControlsLabel = {
        selectAll: "Select all",
        reset: "Reset",
    },
}: SelectControlsProps) {
    return (
        <div className="select__controls">
            <button type="button" onClick={check}>
                {selectControlsLabel.selectAll}
            </button>
            <button type="button" onClick={uncheck}>
                {selectControlsLabel.reset}
            </button>
        </div>
    );
}


export default SelectControls;
